module.exports = __webpack_public_path__ + "img/ybm.dc759bbb.svg";